import { Divider } from '@busybusy/webapp-react-ui';
import { PremiumFeaturesGraphic, ProFeaturesGraphic } from 'assets/images';
import { PremiumFeatureMarketing } from 'components/foundation/state-templates/PremiumFeatureMarketing/PremiumFeatureMarketing';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { FunctionComponent } from 'react';
import './PremiumTrialDialog.scss';
import WistiaVideoEmbedDialog from '../../../../components/foundation/WistiaVideoEmbedDialog/WistiaVideoEmbedDialog';
import { WistiaVideoId } from 'components/foundation/WistiaVideoEmbedDialog/constants';

export const PremiumTrialDialog: FunctionComponent = () => {
  const proFeaturesOpenable = useOpenable();
  const premiumFeaturesOpenable = useOpenable();

  return (
    <div className="premium-trial-dialog">
      <div className="header">
        <h2>{t('Welcome To Your Premium Free Trial!')}</h2>
        <Divider className="my-4" />
        <h5 className="mb-8">{t(`Here's a look at what's included:`)}</h5>
      </div>
      <div className="pro-features">
        <PremiumFeatureMarketing
          image={ProFeaturesGraphic}
          title={t(`All Pro Features`)}
          featureList={[
            t(`Scheduling`),
            t(`Supervisor Tools`),
            t(`Photos & Notes`),
            t(`Kiosk`),
            t(`Safety Sign-Off`),
            t(`Budgets`),
            t(`Activity Reports`),
            t(`Job Costing`),
            t(`Payroll Automation`),
            t(`Over 20+ Additional Features`),
          ]}
          onClick={proFeaturesOpenable.open}
          renderAsPremiumTrial={true}
        />
      </div>
      <div className="premium-features">
        <PremiumFeatureMarketing
          image={PremiumFeaturesGraphic}
          title={t(`All Premium Features`)}
          featureList={[
            t(`Bulletin`),
            t(`Field Reports`),
            t(`Document Sharing`),
            t(`Progress Tracking`),
            t(`API Keys`),
          ]}
          onClick={premiumFeaturesOpenable.open}
          renderAsPremiumTrial={true}
        />
      </div>
      <WistiaVideoEmbedDialog
        isOpen={proFeaturesOpenable.isOpen}
        onClose={proFeaturesOpenable.close}
        videoId={WistiaVideoId.PRO_FEATURES}
      />

      <WistiaVideoEmbedDialog
        isOpen={premiumFeaturesOpenable.isOpen}
        onClose={premiumFeaturesOpenable.close}
        videoId={WistiaVideoId.PREMIUM_FEATURES}
      />
    </div>
  );
};
